module.exports = __webpack_public_path__ + "img/BlinkArt_Sword5_Blue.de93e503.png";